import { createTheme } from '@mui/material/styles';

export const spreeLike = createTheme({
  palette: {
    background: { default: '#FFFFFF', paper: '#FFFFFF' },
    divider: '#E6E8EB',
    text: { primary: '#111827', secondary: '#6B7280' },
    action: { hover: 'rgba(17,24,39,0.04)' },
    primary: { main: '#111827' } as any,
  },
  typography: {
    fontFamily:
      'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji"',
    h6: { fontWeight: 600, fontSize: 15, letterSpacing: 0.2 },
    body2: { fontSize: 13 },
    caption: { fontSize: 12 },
  },
  components: {
    MuiAppBar: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { borderBottom: '1px solid #E6E8EB', backgroundColor: '#FFFFFF' } },
    },
    MuiToolbar: { styleOverrides: { root: { minHeight: 56 } } },
    MuiPaper: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: 10,
          border: `1px solid ${theme.palette.divider}`,
        }),
      },
    },
    MuiButton: {
      styleOverrides: { root: { borderRadius: 8, textTransform: 'none' } },
      defaultProps: { size: 'small' },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 10 },
      },
    },
  },
});

export default spreeLike;
